import * as swcHelpers from '@swc/helpers';
import { useSelector, IntlSelectors, useFeatureToggles } from '@grandvisionhq/state';
import { getShippingData, getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint, getChangedOptIns } from '../../StepShipping/selectors.js';
import { getSelectedOptIns } from '../../utils/get-selected-opt-ins.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import { getCustomerDetailsPayload } from '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';

const usePrepareCustomerDetails = ()=>{
    const shippingDetails = useSelector(getShippingData);
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const selectedStore = useSelector(getSelectedStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const changedOptIns = useSelector(getChangedOptIns);
    const countryCode = useSelector(IntlSelectors.getCountry);
    const locale = useSelector(IntlSelectors.getLocale);
    const { isMultilingualEnabled  } = useFeatureToggles();
    // Only for DK & SE add email optIn to cart as auth0 is not available
    let selectedOptIns = [];
    if (changedOptIns) {
        selectedOptIns = getSelectedOptIns(changedOptIns);
    }
    if (shippingDetails && countryCode && selectedShippingMethod) {
        return {
            customerDetails: swcHelpers.objectSpread({}, getCustomerDetailsPayload({
                shippingDetails,
                opcoCountry: countryCode,
                locale,
                isMultilingualEnabled,
                selectedPickupPoint,
                selectedShippingMethod,
                selectedStore
            }), {
                marketingEmailsOptIn: selectedOptIns.includes('marketingEmailsOptIn')
            })
        };
    } else {
        throw new Error('Need to have shipping details, shippingMethods and a selected shipping method to update on cart!');
    }
};

export { usePrepareCustomerDetails };
//# sourceMappingURL=use-prepare-customer-details.js.map
